import type { IMasterDataDeductionTypeRepository } from "@src/domain/repositories/masterData";
import type { UpdateMasterDataDeductionTypeDTO } from "@src/domain/dto/masterData";

export class UpdateMasterDataDeductionTypeUseCase {
  private readonly repository: IMasterDataDeductionTypeRepository;

  constructor(repository: IMasterDataDeductionTypeRepository) {
    this.repository = repository;
  }

  execute(params: UpdateMasterDataDeductionTypeDTO) {
    return this.repository.updateDeductionType(params);
  }
}
